import { on } from '../helpers/utils';

const selectors = {
  container: '[js-product-form="variant"]',
};

export default () => {
  /**
   * DOM node selectors.
   */
  const nodeSelectors = {
    container: document.querySelectorAll(selectors.container),
  };

  function init() {
    setEvenListeners();
  }


  function setEvenListeners() {
    if (!nodeSelectors.container) {
      return false;
    }

    console.log(`🚧 Variant Linker: Loaded`)

    setTimeout(function(){
      nodeSelectors.container.forEach((item) => {
        item.selectedIndex = "0";
      });
     }, 100);


    nodeSelectors.container.forEach((item) => {
      on('change', item, (event) => updateURL(event));
    });
  }

  function updateURL(event) {
    const url = event.target.value;
    window.location.assign(url)
  }

  /**
   * Public interface.
   */
  return Object.freeze({
    init,
  });
};
